'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _redux = require('redux');

var _deserializeState = require('./deserializeState');

var _deserializeState2 = _interopRequireDefault(_deserializeState);

var _middleware = require('./middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a new redux store
 * @param   {Object} reducers     A key value pair of reducer functions and the state leaf name their are responsible
 * for
 * @param   {Map|String} initialState The initial state. Can either be an immutable object or a string which will be
 * deserialized into an immutable Map
 * @param   {Array} middleware   Array of middleware functions to be applied to the store along side the default
 * reducers
 * @returns {Store} The created redux store
 * @private
 */


// app types
var getStore = function getStore(reducers, initialState, middleware) {
    var appReducers = (0, _reducers2.default)(reducers);
    var state = (0, _deserializeState2.default)(initialState);
    var appMiddleware = (0, _middleware2.default)(middleware);
    var composeMiddleWare = void 0;

    if (process.env.NODE_ENV === 'development') {
        /*eslint-disable */
        var composeWithDevTools = require('redux-devtools-extension').composeWithDevTools;
        /*eslint-enable */
        composeMiddleWare = composeWithDevTools(_redux.applyMiddleware.apply(undefined, (0, _toConsumableArray3.default)(appMiddleware)));
    } else {
        composeMiddleWare = _redux.applyMiddleware.apply(undefined, (0, _toConsumableArray3.default)(appMiddleware));
    }

    return (0, _redux.createStore)(appReducers, state, composeMiddleWare);
};

exports.default = getStore;
//# sourceMappingURL=createStore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/createStore.js
// module id = 269
// module chunks = 0